import { useEffect, useState } from "react";
import { format } from "date-fns";
import { getFinanceJournal } from "../../../../../api/financeJournalApi";
import { mapJournalEntry } from "../mapJournalEntry";

const toApiDate = (date) => (date ? format(date, "yyyy-MM-dd") : undefined);

/**
 * Журнал слоя «Исходные данные»: серверная пагинация и фильтры
 * date_from, date_to, account, organization, q.
 */
function useSourceJournal({ enabled, filters, page, pageSize }) {
  const [debouncedQuery, setDebouncedQuery] = useState({
    search: filters.searchQuery,
    organization: filters.organization,
    account: filters.account,
  });
  const [state, setState] = useState({
    rows: [],
    total: 0,
    loading: false,
    loaded: false,
    error: null,
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedQuery((prev) => {
        if (
          prev.search === filters.searchQuery &&
          prev.organization === filters.organization &&
          prev.account === filters.account
        ) {
          return prev;
        }
        return {
          search: filters.searchQuery,
          organization: filters.organization,
          account: filters.account,
        };
      });
    }, 300);
    return () => clearTimeout(timer);
  }, [filters.searchQuery, filters.organization, filters.account]);

  useEffect(() => {
    if (!enabled) return undefined;

    const controller = new AbortController();
    setState((prev) => ({ ...prev, loading: true, error: null }));

    getFinanceJournal({
      dateFrom: toApiDate(filters.dateFrom),
      dateTo: toApiDate(filters.dateTo),
      account: debouncedQuery.account?.trim() || undefined,
      organization: debouncedQuery.organization?.trim() || undefined,
      q: debouncedQuery.search.trim() || undefined,
      limit: pageSize,
      offset: (page - 1) * pageSize,
      signal: controller.signal,
    })
      .then((data) => {
        const items = Array.isArray(data?.items) ? data.items : [];
        setState({
          rows: items.map(mapJournalEntry),
          total: Number(data?.total) || 0,
          loading: false,
          loaded: true,
          error: null,
        });
      })
      .catch((error) => {
        if (error.name === "AbortError") return;
        setState((prev) => ({
          ...prev,
          loading: false,
          loaded: true,
          error: error.message || "Не удалось загрузить журнал операций",
        }));
      });

    return () => controller.abort();
  }, [
    enabled,
    filters.dateFrom,
    filters.dateTo,
    debouncedQuery,
    page,
    pageSize,
  ]);

  return state;
}

export default useSourceJournal;
